<div id="downloadPopup" #downloadPopup class="download-popup" *ngIf="!isNative">
    <div class="download-card">
        <div class="top">
            <div class="btn-close">
                <button nbButton shape="round" size="small" status="danger" (click)="hidePopUp()">
                    <nb-icon icon="close-outline"></nb-icon>
                </button>
            </div>
        </div>
        <div class="content d-flex mt-1">
            <div class="text-download">
                Download aplikasi SIKAP Badung melalui <span>{{ isMobileIos ? 'App Store' : "Google Play Store"}}</span>
            </div>
            <a class="btn-download ml-3"
                [href]="isMobileIos ? 'https://apps.apple.com/us/app/sikap-badung/id1665792615' : 'https://play.google.com/store/apps/details?id=com.badungkab.sikapbadung'"
                target="_blank">
                <img [src]="isMobileIos ? 'assets/images/appstore-logo.png' : 'assets/images/googleplay-logo.png'" />
            </a>
        </div>
    </div>
</div>